import * as tslib_1 from "tslib";
import { ConfigurationEntryValueType, CredentialStoreGenericType, CredentialStoreResourceType, FeatureValues, FolderType, JobStartStrategy, LicenseFrontOfficeSource, MessageTemplate, RobotHostingType, RobotProvisionType, RobotType, RolesAssignment, TriggerType, UserType, } from '@models';
import { filterAssetResponse, filterIdAndKeyProperties, flattenDynamicProperties, flattenSinglePropertyArrays, mapJobs, mapPackages, mapProcesses, mapSettings, mapTriggers, } from '@utils/audit.utils';
import { safeParse, safeTrim, toDate, } from '@utils/object.utils';
import { isJson } from '@utils/string.utils';
import camelCase from 'lodash-es/camelCase';
import * as moment from 'moment';
import * as XRegExp from 'xregexp';
var EXPIRY_NOTIFICATION_DAYS = 14;
var mapArguments = function (obj, defaultSource) {
    if (!obj) {
        return;
    }
    var args = safeParse(obj);
    if (!args) {
        return args;
    }
    var inputArguments = defaultSource || JSON.stringify({});
    var parsedArguments = JSON.parse(inputArguments);
    (args || []).forEach(function (arg) {
        if (arg.hasDefault) {
            arg.source = 'package';
        }
        if (parsedArguments[arg.name] != null) {
            arg.source = 'process';
        }
    });
    return args;
};
var ɵ0 = mapArguments;
var licenseCode = function (code) { return code ?
    Array(4).join('*') + code.substr(code.length - 6) :
    null; };
var ɵ1 = licenseCode;
var MapperService = /** @class */ (function () {
    function MapperService() {
    }
    Object.defineProperty(MapperService, "messageTemplateMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                value: 'Value',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "robotMap", {
        get: function () {
            return {
                id: 'Id',
                machineName: {
                    property: 'MachineName',
                    out: function (obj) { return safeTrim(obj.machineName); },
                },
                machineId: 'MachineId',
                userId: 'UserId',
                userName: {
                    property: 'Username',
                    out: function (obj) { return safeTrim(obj.userName); },
                },
                password: 'Password',
                credentialStoreId: 'CredentialStoreId',
                externalName: 'ExternalName',
                robotEnvironments: 'RobotEnvironments',
                environments: {
                    property: 'Environments',
                    isCollection: true,
                },
                description: {
                    property: 'Description',
                    out: function (obj) { return safeTrim(obj.description); },
                },
                type: {
                    property: 'Type',
                    in: function (prop) { return RobotType[prop]; },
                    out: function (obj) { return RobotType[obj.type]; },
                },
                hostingType: {
                    property: 'HostingType',
                    in: function (prop) { return RobotHostingType[prop]; },
                    out: function (obj) { return RobotHostingType[obj.hostingType]; },
                },
                provisionType: {
                    property: 'ProvisionType',
                    in: function (prop) { return RobotProvisionType[prop]; },
                    out: function (obj) { return RobotProvisionType[obj.provisionType]; },
                },
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                version: 'Version',
                computedVersion: function (obj) {
                    if (!obj.version) {
                        return null;
                    }
                    if (obj.version.lastIndexOf('.') === -1) {
                        return obj.version;
                    }
                    return obj.version.substring(0, obj.version.lastIndexOf('.'));
                },
                executionSettings: 'ExecutionSettings',
                license: ['License', {
                        timestamp: 'Timestamp',
                    }],
                isCredentialSmartCard: {
                    property: 'CredentialType',
                    in: function (prop) { return prop === 'SmartCard'; },
                    out: function (robot) { return robot.isCredentialSmartCard ? 'SmartCard' : 'Default'; },
                },
                isExternalLicense: 'IsExternalLicensed',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "executionSettingsMap", {
        get: function () {
            var castDefaultValueToProperType = function (defaultValue, valueType) {
                var castedValue;
                switch (valueType) {
                    case 'MultipleChoice':
                        castedValue = defaultValue;
                        break;
                    case 'Integer':
                        castedValue = parseInt(defaultValue, 10);
                        break;
                    case 'Boolean':
                        castedValue = defaultValue.toLowerCase() === 'true';
                }
                return castedValue;
            };
            return {
                configuration: ['Configuration', {
                        key: 'Key',
                        displayName: 'DisplayName',
                        valueType: 'ValueType',
                        possibleValues: 'PossibleValues',
                        defaultValue: {
                            property: 'DefaultValue',
                            in: function (value, entry) { return castDefaultValueToProperType(value, entry.valueType); },
                        },
                    }],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "assetMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                description: {
                    property: 'Description',
                    out: function (obj) { return safeTrim(obj.description); },
                },
                value: 'Value',
                hasDefaultValue: 'HasDefaultValue',
                type: 'ValueType',
                scope: 'ValueScope',
                canBeDeleted: 'CanBeDeleted',
                stringValue: 'StringValue',
                boolValue: 'BoolValue',
                intValue: 'IntValue',
                credentialUsername: 'CredentialUsername',
                credentialPassword: 'CredentialPassword',
                externalName: 'ExternalName',
                credentialStoreId: 'CredentialStoreId',
                robotValues: ['RobotValues', {
                        id: 'Id',
                        robotId: 'RobotId',
                        robotName: 'RobotName',
                        stringValue: 'StringValue',
                        boolValue: 'BoolValue',
                        intValue: 'IntValue',
                        type: 'ValueType',
                        value: 'Value',
                        credentialUsername: 'CredentialUsername',
                        credentialPassword: 'CredentialPassword',
                        externalName: 'ExternalName',
                        credentialStoreId: 'CredentialStoreId',
                    }],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "environmentMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                description: {
                    property: 'Description',
                    out: function (obj) { return safeTrim(obj.description); },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlPackageMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                published: 'LastVersionUploadedOn',
                description: 'Description',
                inputType: 'InputType',
                modelVersions: ['MlPackageVersions', MapperService.mlPackageVersionMap],
                latestVersionInputDescription: 'LatestVersionInputDescription',
                latestVersionOutputDescription: 'LatestVersionOutputDescription',
                status: 'Status',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlPackageVersionMap", {
        get: function () {
            return {
                id: 'Id',
                createdBy: 'Author',
                status: {
                    property: 'Status',
                    in: function (str) {
                        var lowerCase = str.toLocaleLowerCase();
                        return str.charAt(0).toUpperCase() + lowerCase.slice(1);
                    },
                },
                createdOn: 'CreatedOn',
                modifiedOn: 'ModifiedOn',
                version: 'Version',
                changeLog: 'ChangeLog',
                modelLanguage: 'ModelLanguage',
                outputDescription: 'OutputDescription',
                inputType: 'InputType',
                inputDescription: 'InputDescription',
                contentUri: 'ContentUri',
                processorType: 'Processor',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlSkillMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                status: {
                    property: 'Status',
                    in: function (str) {
                        var lowerCase = str.toLowerCase();
                        return str.charAt(0).toUpperCase() + lowerCase.slice(1);
                    },
                },
                processor: 'Processor',
                version: 'Version',
                predictions: 'PredictionCount',
                modelId: 'ModelId',
                currentVersion: 'CurrentVersion',
                previousVersion: 'PreviousVersion',
                description: 'Description',
                createdOn: 'CreatedOn',
                modifiedOn: 'ModifiedOn',
                inputDescription: 'InputDescription',
                outputDescription: 'OutputDescription',
                inputType: 'InputType',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlSkillVersionMap", {
        get: function () {
            return {
                id: 'Id',
                current: 'Current',
                deployedOn: 'DeployedOn',
                deploymentProcessor: 'DeploymentProcessor',
                modelVersionId: 'MlPackageVersionId',
                status: {
                    property: 'Status',
                    in: function (str) {
                        var lowerCase = str.toLowerCase();
                        return str.charAt(0).toUpperCase() + lowerCase.slice(1);
                    },
                },
                uploadedOn: 'UploadedOn',
                version: 'Version',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlLogMetadataMap", {
        get: function () {
            return {
                packageVersion: 'MLPackageVersion',
                packageName: 'MLPackageName',
                skillName: 'MLSkillName',
                skillVersion: 'MLSkillVersion',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "mlLogMap", {
        get: function () {
            return {
                id: 'Id',
                createdOn: 'CreatedOn',
                entityTypeName: {
                    property: 'EntityTypeName',
                    in: function (str) {
                        switch (str) {
                            case 'ML_SKILL':
                                return 'ML Skill';
                            case 'ML_PACKAGE':
                                return 'ML Package';
                            case 'ML_SERVICE':
                                return 'ML Service';
                        }
                        return str;
                    },
                },
                severity: {
                    property: 'Severity',
                    in: function (str) {
                        var lowerCase = str.toLowerCase();
                        return str.charAt(0).toUpperCase() + lowerCase.slice(1);
                    },
                },
                message: 'Message',
                metadata: ['Metadata', MapperService.mlLogMetadataMap],
                errorLog: 'ErrorLog',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "webhookMap", {
        get: function () {
            return {
                id: 'Id',
                url: 'Url',
                enabled: 'Enabled',
                secret: 'Secret',
                subscribeToAllEvents: 'SubscribeToAllEvents',
                allowInsecureSSL: 'AllowInsecureSsl',
                events: {
                    property: 'Events',
                    in: function (events) {
                        return events.map(function (event) { return event.EventType; });
                    },
                    out: function (webhook) {
                        return webhook.events &&
                            webhook.events.map(function (event) { return ({
                                'EventType': event,
                            }); });
                    },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "credentialStore", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                type: {
                    property: 'Type',
                    in: function (value) { return ({
                        value: value,
                        genericType: value === 'Database' ? CredentialStoreGenericType.Database : CredentialStoreGenericType.SecureStore,
                    }); },
                    out: function (credentialStore) { return credentialStore.type.value; },
                },
                additionalConfiguration: {
                    property: 'AdditionalConfiguration',
                    in: function (value) {
                        return safeParse(value, {});
                    },
                    out: function (credentialStore) { return JSON.stringify(credentialStore.additionalConfiguration); },
                },
                details: ['Details', MapperService.credentialStoreDetailsMap],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "credentialStoreDetailsMap", {
        get: function () {
            return {
                isReadOnly: 'IsReadOnly',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "credentialTypeResource", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                type: {
                    property: 'Type',
                    in: function (value) { return CredentialStoreResourceType[value]; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "credentialStoreConfigurationEntryBasicMap", {
        get: function () {
            return {
                key: 'Key',
                displayName: 'DisplayName',
                isMandatory: 'IsMandatory',
                possibleValues: 'PossibleValues',
                defaultValueAsString: 'DefaultValue',
                valueType: 'ValueType',
                defaultValue: function (entry) {
                    if (typeof (entry.defaultValueAsString) === 'string') {
                        switch (entry.valueType) {
                            case ConfigurationEntryValueType.Boolean:
                                return entry.defaultValueAsString.toLocaleLowerCase() === 'true';
                            case ConfigurationEntryValueType.Number:
                                return parseInt(entry.defaultValueAsString, 10);
                            default:
                        }
                    }
                    return entry.defaultValueAsString;
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "credentialStoreConfigurationEntryMap", {
        get: function () {
            return tslib_1.__assign({ configurations: ['Configurations', MapperService.credentialStoreConfigurationEntryBasicMap] }, MapperService.credentialStoreConfigurationEntryBasicMap);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "webhookEventTypeMap", {
        get: function () {
            return {
                name: 'Name',
                group: 'Group',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "auditMap", {
        get: function () {
            var detailExclusions = {};
            return {
                id: 'Id',
                serviceName: 'ServiceName',
                methodName: 'MethodName',
                time: 'ExecutionTime',
                parameters: 'Parameters',
                component: 'Component',
                action: 'Action',
                operation: 'OperationText',
                displayName: 'DisplayName',
                userName: 'UserName',
                userType: 'UserType',
                userId: 'UserId',
                userIsDeleted: 'UserIsDeleted',
                entityId: 'EntityId',
                data: function (entry) {
                    var data = safeParse(entry.parameters, {});
                    var dtoKey = Object.keys(data).filter(function (k) { return k.endsWith('Dto'); })[0];
                    return dtoKey ? data[dtoKey] : {};
                },
                hasDetails: function (entry) {
                    if (!detailExclusions[entry.component]) {
                        return true;
                    }
                    if (detailExclusions[entry.component][entry.action]) {
                        for (var key in detailExclusions[entry.component][entry.action]) {
                            if (entry.data[key] === detailExclusions[entry.component][entry.action][key]) {
                                return false;
                            }
                        }
                    }
                    return true;
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "auditLogDetails", {
        get: function () {
            return {
                action: 'Action',
                entityName: 'EntityName',
                entityId: 'EntityId',
                customData: 'CustomData',
                data: function (entry) {
                    var data = safeParse(entry.customData, {});
                    data.Values = toDate(data.Values);
                    data.OldValues = toDate(data.OldValues);
                    if (['Create', 'Delete'].includes(entry.action)) {
                        data.OldValues = null;
                    }
                    flattenDynamicProperties(data.Values);
                    flattenDynamicProperties(data.OldValues);
                    filterIdAndKeyProperties(data.Values);
                    filterIdAndKeyProperties(data.OldValues);
                    filterAssetResponse(entry, data);
                    flattenSinglePropertyArrays(data.Values);
                    flattenSinglePropertyArrays(data.OldValues);
                    mapSettings(entry, data, MapperService.getInverseSettingsMap());
                    mapJobs(entry, data.Values);
                    mapJobs(entry, data.OldValues);
                    mapTriggers(entry, data.Values);
                    mapTriggers(entry, data.OldValues);
                    mapProcesses(entry, data.Values);
                    mapProcesses(entry, data.OldValues);
                    mapPackages(entry, data.Values);
                    mapPackages(entry, data.OldValues);
                    return {
                        value: data.Values,
                        oldValue: data.OldValues,
                    };
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "logMap", {
        get: function () {
            return {
                id: 'Id',
                time: 'TimeStamp',
                level: 'Level',
                processName: 'ProcessName',
                user: 'WindowsIdentity',
                message: 'Message',
                rawMessage: 'RawMessage',
                robotName: 'RobotName',
                jobKey: 'JobKey',
                machineId: 'MachineId',
                machineName: function (log) { return isJson(log.rawMessage) ? JSON.parse(log.rawMessage).machineName : ''; },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "loginAttemptsMap", {
        get: function () {
            return {
                id: 'Id',
                time: 'CreationTime',
                userId: 'UserId',
                browserInfo: 'BrowserInfo',
                result: 'Result',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "packageMap", {
        get: function () {
            return tslib_1.__assign({ id: 'Id', key: 'Key', description: 'Description', version: 'Version', published: 'Published', isActive: 'IsActive', isLatestVersion: 'IsLatestVersion', releaseNotes: 'ReleaseNotes', authors: 'Authors' }, MapperService.ioPackageArgumentMap);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "ioPackageArgumentMap", {
        get: function () {
            return {
                arguments: {
                    property: 'Arguments',
                    in: function (args, _, original) {
                        if (args == null) {
                            args = {};
                        }
                        return {
                            input: mapArguments(args['Input'], original['InputArguments']),
                            output: mapArguments(args['Output']),
                        };
                    },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "processSettingsMap", {
        get: function () {
            return {
                processSettings: {
                    property: 'ProcessSettings',
                    in: function (obj) { return ({
                        enabled: obj && obj.ErrorRecordingEnabled,
                        duration: obj && obj.Duration,
                        frequency: obj && obj.Frequency,
                        quality: obj && obj.Quality,
                        autoStartProcess: obj && obj.AutoStartProcess,
                    }); },
                    out: function (obj) { return obj.processSettings ? ({
                        ErrorRecordingEnabled: obj.processSettings.enabled,
                        Duration: obj.processSettings.duration,
                        Frequency: obj.processSettings.frequency,
                        Quality: obj.processSettings.quality,
                        AutoStartProcess: obj.processSettings.autoStartProcess,
                    }) : undefined; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                description: {
                    property: 'Description',
                    out: function (obj) { return safeTrim(obj.description); },
                },
                maxNoOfRetries: 'MaxNumberOfRetries',
                acceptAutoRetry: 'AcceptAutomaticallyRetry',
                enforceUniqueReference: 'EnforceUniqueReference',
                triggerId: 'ProcessScheduleId',
                processId: 'ReleaseId',
                processName: 'ReleaseName',
                specificDataJsonSchema: 'SpecificDataJsonSchema',
                outputDataJsonSchema: 'OutputDataJsonSchema',
                analyticsDataJsonSchema: 'AnalyticsDataJsonSchema',
                slaMinutes: 'SlaInMinutes',
                riskSlaMinutes: 'RiskSlaInMinutes',
                releaseId: 'ReleaseId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueItemMap", {
        get: function () {
            return {
                id: 'Id',
                key: 'Key',
                reference: 'Reference',
                priority: 'Priority',
                deferDate: 'DeferDate',
                dueDate: 'DueDate',
                queueDefinitionId: 'QueueDefinitionId',
                status: 'Status',
                processingExceptionId: 'ProcessingExceptionId',
                processingExceptionType: 'ProcessingExceptionType',
                processingException: ['ProcessingException', {
                        reason: 'Reason',
                        details: 'Details',
                        type: 'Type',
                        id: 'Id',
                    }],
                robot: ['Robot', MapperService.robotMap],
                reviewerUser: ['ReviewerUser', MapperService.userMap],
                startProcessing: 'StartProcessing',
                endProcessing: 'EndProcessing',
                anchestorId: 'AncestorId',
                retryNumber: 'RetryNumber',
                creationTime: 'CreationTime',
                specificContent: 'SpecificContent',
                output: 'Output',
                analytics: 'Analytics',
                reviewStatus: 'ReviewStatus',
                progress: 'Progress',
                rowVersion: 'RowVersion',
                queueDefinition: ['QueueDefinition', MapperService.queueMap],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueItemDtoMap", {
        get: function () {
            return {
                name: 'Name',
                priority: 'Priority',
                specificContent: 'SpecificContent',
                deferDate: 'DeferDate',
                dueDate: 'DueDate',
                reference: 'Reference',
                progress: 'Progress',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "bulkQueueItemResponseMap", {
        get: function () {
            return {
                success: 'Success',
                message: 'Message',
                failedItems: ['FailedItems', MapperService.bulkQueueItemFailedResponseMap],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "bulkQueueItemFailedResponseMap", {
        get: function () {
            return {
                row: 'Ordinal',
                errorCode: 'ErrorCode',
                errorMessage: 'ErrorMessage',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueItemCommentMap", {
        get: function () {
            return {
                id: 'Id',
                queueItemId: 'QueueItemId',
                creationTime: 'CreationTime',
                userId: 'UserId',
                userName: 'UserName',
                text: 'Text',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueItemEventMap", {
        get: function () {
            return {
                id: 'Id',
                queueItemId: 'QueueItemId',
                timestamp: 'Timestamp',
                action: 'Action',
                data: 'Data',
                userId: 'UserId',
                userName: 'UserName',
                status: 'Status',
                reviewStatus: 'ReviewStatus',
                reviewerUserId: 'ReviewerUserId',
                reviewerUserName: 'ReviewerUserName',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "processVersionMap", {
        get: function () {
            return {
                id: 'Id',
                versionNumber: 'VersionNumber',
                creationTime: 'CreationTime',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "processMap", {
        get: function () {
            return tslib_1.__assign({ id: 'Id', key: 'Key', name: 'Name', description: {
                    property: 'Description',
                    out: function (obj) { return safeTrim(obj.description); },
                }, status: 'Status', environmentName: 'EnvironmentName', environmentId: 'EnvironmentId', processKey: 'ProcessKey', processVersion: 'ProcessVersion', isLatestVersion: 'IsLatestVersion', isProcessDeleted: 'IsProcessDeleted', currentVersion: ['CurrentVersion', MapperService.processVersionMap], environment: ['Environment', MapperService.environmentMap], releaseVersions: ['ReleaseVersions', MapperService.processVersionMap], inputArguments: {
                    property: 'InputArguments',
                    in: function (inputArguments) { return safeParse(inputArguments); },
                    out: function (entity) { return JSON.stringify(entity.inputArguments); },
                } }, MapperService.ioPackageArgumentMap, MapperService.processSettingsMap);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "userRolesMap", {
        get: function () {
            return {
                tenantRoles: ['TenantRoles', MapperService.userRoleMap],
                folderRoles: ['PageItems', MapperService.folderRoleMap],
                count: 'Count',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "userRoleMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                source: ['Users', MapperService.roleSourceMap],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "roleSourceMap", {
        get: function () {
            return {
                id: 'Id',
                username: 'UserName',
                isInherited: 'IsInherited',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "folderRoleMap", {
        get: function () {
            return {
                folder: ['Folder', {
                        id: 'Id',
                        fullyQualifiedName: 'FullyQualifiedName',
                        displayName: 'DisplayName',
                    }],
                roles: ['Roles', MapperService.userRoleMap],
                id: function (obj) { return obj.folder.id; },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "roleMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                displayName: 'DisplayName',
                permissions: ['Permissions', MapperService.permissionMap],
                isEditable: 'IsEditable',
                isStatic: 'IsStatic',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "permissionMap", {
        get: function () {
            return {
                name: 'Name',
                isGranted: 'IsGranted',
                scope: 'Scope',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "settingMap", {
        get: function () {
            return {
                name: 'Name',
                value: 'Value',
                scope: 'Scope',
                id: function (obj) { return obj.name; },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "licenseBaseMap", {
        get: function () {
            return {
                expirationDate: {
                    property: 'ExpireDate',
                    in: function (epoch) { return new Date(new Date(0).setSeconds(epoch)); },
                },
                gracePeriodEndDate: {
                    property: 'GracePeriodEndDate',
                    in: function (epoch) { return new Date(new Date(0).setSeconds(epoch)); },
                },
                allowed: ['Allowed', MapperService.licenseFieldsMap],
                used: ['Used', MapperService.licenseFieldsMap],
                isRegistered: 'IsRegistered',
                isExpired: 'IsExpired',
                features: {
                    property: 'LicensedFeatures',
                    in: function (obj) {
                        var o = {};
                        return !!obj ? obj.reduce(function (acc, curr) { acc[curr] = true; return acc; }, o) : o;
                    },
                },
                developmentConcurrent: 'DevelopmentConcurrent',
                attendedConcurrent: 'AttendedConcurrent',
                studioXConcurrent: 'StudioXConcurrent',
                hostLicenseId: 'HostLicenseId',
                code: {
                    property: 'Code',
                    in: licenseCode,
                },
                isCommunity: function (obj) { return !obj.isExpired && !obj.isRegistered; },
                expiresSoon: function (obj) { return moment(obj.expirationDate)
                    .subtract(EXPIRY_NOTIFICATION_DAYS, 'days')
                    .isBefore() &&
                    !obj.isExpired; },
                totals: {
                    property: '',
                    in: function (_, license) {
                        if (!license) {
                            return license;
                        }
                        var totals = {};
                        Object.keys(license.allowed).forEach(function (key) {
                            totals[key] = Math.min(100, Math.round(license.used[key] / license.allowed[key] * 100) || 0);
                        });
                        return totals;
                    },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "licenseMap", {
        get: function () {
            return MapperService.licenseBaseMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "licenseFieldsMap", {
        get: function () {
            return {
                attended: 'Attended',
                unattended: 'Unattended',
                nonProduction: 'NonProduction',
                development: 'Development',
                studioX: 'StudioX',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "runtimeLicenseMap", {
        get: function () {
            return {
                key: 'Key',
                machineId: 'MachineId',
                isOnline: 'IsOnline',
                isLicensed: 'IsLicensed',
                machineName: 'MachineName',
                robotsCount: 'RobotsCount',
                runtimes: 'Runtimes',
                executingCount: 'ExecutingCount',
                enabled: 'Enabled',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "namedLicenseMap", {
        get: function () {
            return {
                activeRobotId: 'ActiveRobotId',
                key: 'Key',
                userName: 'UserName',
                lastLogin: 'LastLoginDate',
                machines: 'MachinesCount',
                machineNames: {
                    property: 'MachineNames',
                    in: function (machineNames) { return machineNames.join(', '); },
                },
                activeMachineNames: 'ActiveMachineNames',
                // don't display the machine for AD users
                displayMachineNames: function (entry) { return !(entry.userName || '').includes("\\") ? entry.machineNames : ''; },
                displayMachineNamesTooltip: {
                    property: 'ActiveMachineNames',
                    in: function (activeMachineNames) { return activeMachineNames.join(', '); },
                },
                isLicensed: 'IsLicensed',
                source: {
                    property: 'IsExternalLicensed',
                    in: function (isExternalLicense) { return isExternalLicense
                        ? LicenseFrontOfficeSource.Local
                        : LicenseFrontOfficeSource.Orchestrator; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "hostLicenseMap", {
        get: function () {
            return tslib_1.__assign({}, MapperService.licenseBaseMap, { id: 'Id', uploadDate: 'CreationTime', tenantCount: 'TenantsCount' });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "tenantLicenseMap", {
        get: function () {
            return {
                tenantId: 'TenantId',
                hostLicenseId: 'HostLicenseId',
                attended: 'Attended',
                unattended: 'Unattended',
                nonProduction: 'NonProduction',
                development: 'Development',
                studioX: 'StudioX',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "transactionMap", {
        get: function () {
            return {
                id: 'QueueDefinitionId',
                name: 'QueueDefinitionName',
                description: 'QueueDefinitionDescription',
                acceptAutoRetry: 'QueueDefinitionAcceptAutomaticallyRetry',
                maxNoOfRetries: 'QueueDefinitionMaxNumberOfRetries',
                enforceUniqueReference: 'QueueDefinitionEnforceUniqueReference',
                itemsToProcess: 'ItemsToProcess',
                itemsInProgress: 'ItemsInProgress',
                avgTime: 'ProcessingMeanTime',
                successfulTransactions: 'SuccessfulTransactionsNo',
                applicationExceptions: 'ApplicationExceptionsNo',
                businessExceptions: 'BusinessExceptionsNo',
                processName: 'ReleaseName',
                triggerId: 'ProcessScheduleId',
                specificDataJsonSchemaExists: 'SpecificDataJsonSchemaExists',
                outputDataJsonSchemaExists: 'OutputDataJsonSchemaExists',
                analyticsDataJsonSchemaExists: 'AnalyticsDataJsonSchemaExists',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "transactionStatsMap", {
        get: function () {
            return {
                id: 'QueueDefinitionId',
                processingTime: 'ProcessingTime',
                reportType: 'ReportType',
                applicationExceptionNo: 'NumberOfApplicationExceptions',
                businessExceptionNo: 'NumberOfBusinessExceptions',
                successNo: 'NumberOfSuccessfulTransactions',
                retriedItems: 'NumberOfRetriedItems',
                appExProcTime: 'ApplicationExceptionsProcessingTime',
                businessExProcTime: 'BusinessExceptionsProcessingTime',
                successProcTime: 'SuccessfulTransactionsProcessingTime',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "triggerGridMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                enabled: 'Enabled',
                queueDefinitionId: 'QueueDefinitionId',
                queueDefinitionName: 'QueueDefinitionName',
                packageName: 'PackageName',
                environmentName: 'EnvironmentName',
                startProcessCronSummary: 'StartProcessCronSummary',
                startProcessNextOccurrence: 'StartProcessNextOccurrence',
                stopProcessExpression: 'StopProcessExpression',
                timezoneIana: 'TimeZoneIana',
                startStrategy: 'StartStrategy',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "triggerUpsertMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                inputArguments: {
                    property: 'InputArguments',
                    in: function (prop) { return safeParse(prop) || {}; },
                    out: function (obj) { return JSON.stringify(obj.inputArguments); },
                },
                enabled: 'Enabled',
                useCalendar: 'UseCalendar',
                calendar: {
                    property: ['CalendarId'],
                    in: function (obj) { return [{
                            id: obj['CalendarId'],
                            text: '',
                        }]; },
                    out: function (obj) { return ({
                        'CalendarId': obj.calendar && obj.calendar[0] ? obj.calendar[0].id : undefined,
                    }); },
                },
                itemsActivationThreshold: 'ItemsActivationThreshold',
                itemsPerJobActivationTarget: 'ItemsPerJobActivationTarget',
                maxJobsForActivation: 'MaxJobsForActivation',
                startProcessCronDetails: 'StartProcessCronDetails',
                startProcessCron: {
                    property: 'StartProcessCron',
                    out: function (obj) { return safeTrim(obj.startProcessCron); },
                },
                environmentId: {
                    property: 'EnvironmentId',
                    in: function (prop) { return Number(prop); },
                },
                executorRobots: ['ExecutorRobots', {
                        id: 'Id',
                    }],
                stopStrategy: 'StopStrategy',
                stopEnabled: {
                    property: 'StopProcessExpression',
                    in: function (prop) { return !!prop; },
                    out: function (obj) { return obj.stopEnabled ?
                        (obj.stopDays * 86400 + obj.stopHours * 3600 + obj.stopMinutes * 60).toString() :
                        ''; },
                },
                stopDays: {
                    property: 'StopProcessExpression',
                    in: function (prop) { return prop ?
                        Math.trunc(parseInt(prop, 10) / 86400) :
                        0; },
                },
                stopHours: {
                    property: 'StopProcessExpression',
                    in: function (prop) { return prop ?
                        Math.trunc(parseInt(prop, 10) % 86400 / 3600) :
                        0; },
                },
                stopMinutes: {
                    property: 'StopProcessExpression',
                    in: function (prop) { return prop ?
                        Math.trunc(parseInt(prop, 10) % 3600 / 60) :
                        0; },
                },
                process: {
                    property: ['ReleaseId', 'ReleaseName'],
                    in: function (obj) { return [{
                            id: obj['ReleaseId'],
                            text: obj['ReleaseName'],
                        }]; },
                    out: function (obj) { return ({
                        'ReleaseId': obj.process[0].id,
                        'ReleaseName': obj.process[0].text,
                    }); },
                },
                queue: {
                    property: ['QueueDefinitionId', 'QueueDefinitionName'],
                    in: function (obj) { return [{
                            id: obj['QueueDefinitionId'],
                            text: obj['QueueDefinitionName'],
                        }]; },
                    out: function (obj) { return ({
                        'QueueDefinitionId': obj.queue ?
                            obj.queue[0].id :
                            null,
                        'QueueDefinitionName': obj.queue ?
                            obj.queue[0].text :
                            null,
                    }); },
                },
                timezone: {
                    property: 'TimeZoneId',
                    in: function (prop) { return [{
                            id: prop,
                        }]; },
                    out: function (obj) { return obj.timezone[0].id; },
                },
                type: {
                    property: 'QueueDefinitionId',
                    in: function (prop) { return prop ? TriggerType.Queue : TriggerType.Time; },
                },
                startStrategyRadio: {
                    property: 'StartStrategy',
                    in: function (prop) {
                        switch (prop) {
                            case -1:
                                return JobStartStrategy.AllRobots;
                            case 0:
                                return JobStartStrategy.SpecificRobots;
                            default:
                                return JobStartStrategy.JobsCount;
                        }
                    },
                },
                startStrategy: 'StartStrategy',
                stopProcessDate: 'StopProcessDate',
                disableAfter: {
                    property: 'StopProcessDate',
                    in: function (prop) { return !!prop; },
                },
                externalJobKey: 'ExternalJobKey',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "sessionMap", {
        get: function () {
            return {
                id: 'Id',
                folder: 'FolderName',
                robot: ['Robot', MapperService.robotMap],
                state: 'State',
                reportingTime: 'ReportingTime',
                isUnresponsive: 'IsUnresponsive',
                machineId: 'MachineId',
                machineName: 'MachineName',
                info: 'Info',
                hostMachineName: 'HostMachineName',
                licenseErrorCode: 'LicenseErrorCode',
                computedState: function (obj) {
                    return obj.isUnresponsive ? 'Unresponsive' : obj.state;
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "sessionUpdatedMap", {
        get: function () {
            return {
                state: 'state',
                reportingTime: 'reportingTime',
                isUnresponsive: 'isUnresponsive',
                hostMachineName: 'hostMachineName',
                machineName: 'machineName',
                id: 'sessionId',
                robotId: 'robotId',
                isNew: 'isNew',
                licenseErrorCode: 'licenseErrorCode',
                computedState: function (obj) {
                    return obj.isUnresponsive ? 'Unresponsive' : obj.state;
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "jobTriggerMap", {
        get: function () {
            return {
                id: 'Id',
                jobId: 'JobId',
                status: 'Status',
                triggerType: 'TriggerType',
                triggerMessage: 'TriggerMessage',
                itemId: 'ItemId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "jobMap", {
        get: function () {
            return {
                id: 'Id',
                key: 'Key',
                startTime: 'StartTime',
                endTime: 'EndTime',
                info: 'Info',
                state: 'State',
                source: 'Source',
                sourceType: 'SourceType',
                creationTime: 'CreationTime',
                robot: ['Robot', MapperService.robotMap],
                release: ['Release', MapperService.processMap],
                environmentName: {
                    property: 'Release/Name',
                    in: function (_, obj) {
                        if (obj && obj.release) {
                            var fullReleaseName = obj.release.name;
                            var processName = obj.release.processKey;
                            var environmentName = fullReleaseName.substring(processName.length + 1);
                            return environmentName;
                        }
                        return '';
                    },
                },
                startingTriggerId: 'StartingScheduleId',
                type: 'Type',
                inputArguments: {
                    property: 'InputArguments',
                    in: function (obj) { return safeParse(obj); },
                    out: function (obj) { return JSON.stringify(obj.inputArguments); },
                },
                outputArguments: {
                    property: 'OutputArguments',
                    in: function (obj) { return safeParse(obj); },
                },
                hostMachineName: 'HostMachineName',
                hasMediaRecorded: 'HasMediaRecorded',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "userMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                surname: {
                    property: 'Surname',
                    out: function (obj) { return safeTrim(obj.surname); },
                },
                userName: 'UserName',
                domain: 'Domain',
                fullName: 'FullName',
                emailAddress: 'EmailAddress',
                isEmailConfirmed: 'IsEmailConfirmed',
                isActive: 'IsActive',
                authenticationSource: 'AuthenticationSource',
                password: 'Password',
                lastLoginDate: 'LastLoginTime',
                creationTime: 'CreationTime',
                rolesList: 'RolesList',
                organizationUnits: [
                    'OrganizationUnits',
                    MapperService.organizationUnitMap,
                ],
                tenancyName: 'TenancyName',
                tenantDisplayName: 'TenantDisplayName',
                tenancyId: 'TenantId',
                type: {
                    property: 'Type',
                    in: function (prop) { return UserType[prop]; },
                    out: function (obj) { return UserType[obj.type]; },
                },
                notificationSettings: ['NotificationSubscription', {
                        transactions: 'QueueItems',
                        robots: 'Robots',
                        jobs: 'Jobs',
                        tasks: 'Tasks',
                        schedules: 'Schedules',
                        queues: 'Queues',
                    }],
                mayHaveRobotSession: 'MayHaveRobotSession',
                mayHaveUserSession: 'MayHaveUserSession',
                bypassBasicAuthRestriction: 'BypassBasicAuthRestriction',
                robotProvision: ['RobotProvision', MapperService.robotProvisionMap],
                isExternalLicensed: 'IsExternalLicensed',
                licenseType: {
                    property: 'LicenseType',
                    in: function (prop) { return prop != null ? RobotType[prop] : prop; },
                    out: function (obj) { return obj.licenseType != null ? RobotType[obj.licenseType] : obj.licenseType; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "userLoginInfoMap", {
        get: function () {
            return {
                id: 'Id',
                userName: 'UserName',
                name: 'Name',
                surname: 'Surname',
                emailAddress: 'EmailAddress',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "tenantMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                displayName: 'DisplayName',
                adminEmailAddress: 'AdminEmailAddress',
                adminName: 'AdminName',
                adminSurname: 'AdminSurname',
                adminPassword: 'AdminPassword',
                lastLoginTime: 'LastLoginTime',
                isActive: 'IsActive',
                license: ['License', {
                        id: 'Id',
                        hostLicenseId: 'HostLicenseId',
                        code: {
                            property: 'Code',
                            in: licenseCode,
                        },
                        allowed: ['Allowed', MapperService.licenseFieldsMap],
                    }],
                hasConnectionString: 'HasConnectionString',
                connectionString: 'ConnectionString',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "tenantFeatureMap", {
        get: function () {
            return {
                featureSettings: ['FeatureSettings', MapperService.featureSettingMap],
                tenantId: 'TenantId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "featureSettingMap", {
        get: function () {
            return {
                displayName: 'DisplayName',
                name: 'Name',
                value: {
                    property: 'Value',
                    in: function (featureValue) { return (featureValue === FeatureValues.True); },
                },
                notEditable: 'NotEditable',
                tooltip: 'Tooltip',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "alertMap", {
        get: function () {
            return {
                id: 'Id',
                name: 'NotificationName',
                component: {
                    property: 'Component',
                    in: function (component) {
                        return component === 'Schedules'
                            ? 'Triggers'
                            : component;
                    },
                },
                data: {
                    property: 'Data',
                    in: function (json) {
                        var parsed = safeParse(json, {});
                        var keys = Object.keys(parsed);
                        var mapped = {};
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var key = keys_1[_i];
                            mapped[camelCase(key)] = parsed[key];
                        }
                        return mapped;
                    },
                },
                showDetails: {
                    property: 'Component',
                    in: function (component) {
                        switch (component) {
                            case 'Transactions':
                            case 'Jobs':
                            case 'Process':
                                return true;
                            case 'Queues':
                                return false;
                            default:
                                return false;
                        }
                    },
                },
                permissions: {
                    property: 'Component',
                    in: function (component) {
                        switch (component) {
                            case 'Transactions':
                                return ['Transactions.View', 'Queues.View'];
                            case 'Jobs':
                                return ['Jobs.View'];
                            case 'Process':
                            case 'Queues':
                                return ['Alerts.View'];
                        }
                    },
                },
                severity: 'Severity',
                timestamp: 'CreationTime',
                state: 'State',
                userNotificationId: 'UserNotificationId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "organizationUnitMap", {
        get: function () {
            return {
                id: 'Id',
                displayName: {
                    property: 'DisplayName',
                    out: function (obj) { return safeTrim(obj.displayName); },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "foldersMap", {
        get: function () {
            return {
                id: 'Id',
                displayName: 'DisplayName',
                description: 'Description',
                hasChildren: 'HasChildren',
                rolesAssignment: {
                    property: 'PermissionModel',
                    in: function (obj) { return obj === 'FineGrained' ? RolesAssignment.CustomRoles : RolesAssignment.InheritFromTenant; },
                    out: function (obj) { return !!obj.rolesAssignment
                        ? obj.rolesAssignment === RolesAssignment.CustomRoles ? 'FineGrained' : 'InheritFromTenant'
                        : undefined; },
                },
                isSelectable: 'IsSelectable',
                type: {
                    property: 'ProvisionType',
                    in: function (obj) { return obj === 'Automatic' ? FolderType.Modern : FolderType.Classic; },
                    out: function (obj) { return !!obj.type
                        ? obj.type === FolderType.Modern ? 'Automatic' : 'Manual'
                        : undefined; },
                },
                fullyQualifiedName: 'FullyQualifiedName',
                parentId: 'ParentId',
                level: {
                    property: 'Level',
                    in: function (level) { return level + 1; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "folderAssignmentsMap", {
        get: function () {
            return {
                id: 'Id',
                user: ['UserEntity', {
                        id: 'Id',
                        userName: 'UserName',
                        isInherited: 'IsInherited',
                    }],
                roles: ['Roles', {
                        id: 'Id',
                        name: 'Name',
                        origin: 'Origin',
                        inheritedFromFolder: ['InheritedFromFolder', {
                                id: 'Id',
                                fullyQualifiedName: 'FullyQualifiedName',
                                displayName: {
                                    property: 'DisplayName',
                                    out: function (obj) { return safeTrim(obj.displayName); },
                                },
                            }],
                    }],
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "bulkOperationMap", {
        get: function () {
            return {
                success: 'Success',
                message: 'Message',
                failedItems: 'FailedItems',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "queueItemIdentifierMap", {
        get: function () {
            return {
                id: 'Id',
                rowVersion: 'RowVersion',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "changePasswordMap", {
        get: function () {
            return {
                currentPassword: 'CurrentPassword',
                newPassword: 'NewPassword',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "machineMap", {
        get: function () {
            return {
                id: 'Id',
                name: {
                    property: 'Name',
                    out: function (obj) { return safeTrim(obj.name); },
                },
                type: 'Type',
                robotVersions: {
                    property: 'RobotVersions',
                    in: function (robotVersions) {
                        if (!robotVersions) {
                            return [];
                        }
                        var versions = robotVersions.map(function (item) { return ({
                            count: item.Count,
                            version: item.Version && item.Version.substring(0, item.Version.lastIndexOf('.') !== -1 ?
                                item.Version.lastIndexOf('.') :
                                item.Version.length),
                        }); });
                        return versions.reduce(function (acc, curr) {
                            var existing = acc.find(function (robot) { return robot.version === curr.version; });
                            if (existing) {
                                existing.count += curr.count;
                            }
                            else {
                                acc.push(curr);
                            }
                            return acc;
                        }, []);
                    },
                },
                licenseKey: 'LicenseKey',
                nonProductionSlots: 'NonProductionSlots',
                unattendedSlots: 'UnattendedSlots',
                description: 'Description',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "changeExpiredPasswordMap", {
        get: function () {
            return tslib_1.__assign({}, MapperService.changePasswordMap, { userId: 'UserId' });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "robotProvisionMap", {
        get: function () {
            return {
                isExternalLicensed: 'IsExternalLicensed',
                userName: 'UserName',
                executionSettings: 'ExecutionSettings',
                type: {
                    property: 'RobotType',
                    in: function (prop) { return prop != null ? RobotType[prop] : prop; },
                    out: function (obj) { return obj.type != null ? RobotType[obj.type] : obj.type; },
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    MapperService.authSettingsMapper = function (settings) {
        var getProp = function (prop) {
            var idx = settings.Keys.indexOf(prop);
            return settings.Values[idx];
        };
        return {
            serverSettings: {
                path: getProp('Application.Path'),
                build: {
                    version: getProp('Build.Version'),
                    date: getProp('Build.Date'),
                },
                baseTitle: getProp('Application.Title'),
                year: getProp('Application.Year'),
            },
            passwordComplexity: this.passwordComplexityMapper(getProp('PasswordComplexity')),
            application: {
                isTenantRegistrationEnabled: getProp('Tenant.Registration.Enabled') === 'true',
                termsAndConditionsRegisterUrl: getProp('TermsAndConditionsRegisterUrl'),
                isLocalizationEnabled: getProp('Localization.Enabled') === 'True',
            },
            mixpanelKey: getProp('Mixpanel.Key'),
            isTelemetryEnabled: getProp('Telemetry.Enabled') === 'True',
            currentCulture: getProp('CurrentCulture'),
            loginLayout: getProp(MessageTemplate.LoginLayout),
            isRememberMeEnabled: getProp('Auth.RememberMe.Enabled') === 'True',
            cloud: {
                allowPasswordChange: getProp('Auth.AllowChangePassword') === 'True',
                allowSelfEmailUpdate: getProp('Auth.AllowSelfEmailUpdate') === 'True',
                logoutUrl: getProp('Auth.ExternalLogoutUrl'),
            },
            auth: {
                isCustomSsoEnabled: getProp('CustomSsoCookie.Enabled') === 'True',
                isGoogleAuthenticationEnabled: getProp('ExternalAuth.Google.Enabled') === 'true',
                isWindowsAuthenticationEnabled: getProp('WindowsAuth.Enabled') === 'true',
                isAzureAuthenticationEnabled: getProp('ExternalAuth.AzureAD.Enabled') === 'true',
                isSaml2AuthenticationEnabled: getProp('ExternalAuth.Saml2.Enabled') === 'true',
                isSystemOpenIdAuthenticationEnabled: getProp('ExternalAuth.System.OpenIdConnect.Enabled') === 'true',
            },
        };
    };
    Object.defineProperty(MapperService, "excludedCalendarMapper", {
        get: function () {
            return {
                calendarId: 'Id',
                calendarName: 'Name',
                timeZoneId: 'TimeZoneId',
                excludedDates: 'ExcludedDates',
                newEntry: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskMapper", {
        get: function () {
            return {
                id: 'Id',
                taskPriority: 'Priority',
                title: 'Title',
                creationTime: 'CreationTime',
                status: 'Status',
                type: 'Type',
                assignedToUser: ['AssignedToUser', MapperService.userLoginInfoMap],
                taskCatalogName: 'TaskCatalogName',
                organizationUnitId: 'OrganizationUnitId',
                isCompleted: 'IsCompleted',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskAssignmentRequestMap", {
        get: function () {
            return {
                taskId: 'TaskId',
                userId: 'UserId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskAssignmentResponseMap", {
        get: function () {
            return {
                taskId: 'TaskId',
                userId: 'UserId',
                errorCode: 'ErrorCode',
                errorMessage: 'ErrorMessage',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskCatalogMapper", {
        get: function () {
            return {
                id: 'Id',
                name: 'Name',
                description: 'Description',
                modificationTime: 'LastModificationTime',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskCatalogRequestMapper", {
        get: function () {
            return {
                name: 'Name',
                description: 'Description',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "taskFormMapper", {
        get: function () {
            return {
                formLayout: 'formLayout',
                data: 'data',
                action: 'action',
                actionLabel: 'actionLabel',
                status: 'status',
                assignedToUserId: 'assignedToUserId',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "smtpParametersMap", {
        get: function () {
            return {
                smtpHost: 'Host',
                smtpPort: 'Port',
                smtpDomain: 'Domain',
                smtpUsername: 'UserName',
                smtpPassword: 'Password',
                smtpUseDefaultCredentials: 'UseDefaultCredentials',
                smtpEnableSsl: 'EnableSsl',
                defaultFromAddress: 'DefaultFromAddress',
                defaultFromDisplayName: 'DefaultFromDisplayName',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "dashboardEntryMap", {
        get: function () {
            return {
                id: '_id',
                oid: 'oid',
                title: 'title',
                widgetCount: 'widgetCount',
                lastUpdated: 'lastUpdated',
                lastPublished: 'lastPublish',
                ownerInfo: 'ownerInfo',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapperService, "suggestValueMap", {
        get: function () {
            return {
                id: 'oid',
                text: 'title',
            };
        },
        enumerable: true,
        configurable: true
    });
    MapperService.passwordComplexityMapper = function (passComplexity) {
        var complexity = safeParse(passComplexity);
        var serverRegex = complexity['RegexComplexity'];
        var regexSuffix = 'Regex';
        var regex = {
            hasDigits: XRegExp(serverRegex['HasDigit' + regexSuffix]),
            hasLowerCase: XRegExp(serverRegex['HasLowercase' + regexSuffix]),
            hasSpecialCharacter: XRegExp(serverRegex['HasSpecialCharacter' + regexSuffix]),
            hasUpperCase: XRegExp(serverRegex['HasUppercase' + regexSuffix]),
        };
        return {
            hasDigits: complexity['HasDigit'],
            hasLowerCase: complexity['HasLowercase'],
            hasSpecialCharacter: complexity['HasSpecialCharacter'],
            hasUpperCase: complexity['HasUppercase'],
            length: complexity['Length'],
            regex: regex,
        };
    };
    MapperService.settingsMappings = {
        mail: {
            alertsEmailEnabled: 'Alerts.Email.Enabled',
            smtpHost: 'Abp.Net.Mail.Smtp.Host',
            smtpPort: 'Abp.Net.Mail.Smtp.Port',
            smtpDomain: 'Abp.Net.Mail.Smtp.Domain',
            smtpUsername: 'Abp.Net.Mail.Smtp.UserName',
            smtpPassword: 'Abp.Net.Mail.Smtp.Password',
            smtpUseDefaultCredentials: 'Abp.Net.Mail.Smtp.UseDefaultCredentials',
            smtpEnableSsl: 'Abp.Net.Mail.Smtp.EnableSsl',
            defaultFromAddress: 'Abp.Net.Mail.DefaultFromAddress',
            defaultFromDisplayName: 'Abp.Net.Mail.DefaultFromDisplayName',
        },
        general: {
            timezone: 'Abp.Timing.TimeZone',
            language: 'Abp.Localization.DefaultLanguageName',
            isModernFolderSystemEnabled: 'Features.ModernFolders.Enabled',
        },
        security: {
            passwordComplexity: 'PasswordComplexity',
            complexity: {
                hasDigits: 'HasDigit',
                hasLowerCase: 'HasLowercase',
                hasSpecialCharacter: 'HasSpecialCharacter',
                hasUpperCase: 'HasUppercase',
                length: 'Length',
                regex: 'RegexComplexity',
            },
            password: {
                defaultExpirationDays: 'Auth.Password.DefaultExpirationDays',
                previousUseLimit: 'Auth.Password.PreviousUseLimit',
                shouldChangePasswordAfterFirstLogin: 'Auth.Password.ShouldChangePasswordAfterFirstLogin',
            },
            lockout: {
                isEnabled: 'Auth.UserLockOut.IsEnabled',
                maxAccessAttempts: 'Auth.UserLockOut.MaxFailedAccessAttemptsBeforeLockout',
                defaultAccountLockoutSeconds: 'Auth.UserLockOut.DefaultAccountLockoutSeconds',
            },
            robot: {
                runDisconnected: 'AttendedRobot.RunDisconnectedHours',
            },
        },
        scalability: {
            signalREnabled: 'Scalability.SignalR.Enabled',
            signalRTransport: 'Scalability.SignalR.Transport',
        },
        deployment: {
            packages: {
                isInternalDeployment: 'InternalDeployment',
                deploymentUrl: 'DeploymentUrl',
                authenticationType: 'Deployment.Processes.AuthenticationType',
                apiKey: 'NuGet.Packages.ApiKey',
                basicAuthUsername: 'DeploymentBasicUsername',
                basicAuthPassword: 'DeploymentBasicPassword',
            },
            libraries: {
                useSharedFeed: 'Deployment.Libraries.UseSharedFeed',
                allowTenantPublish: 'Deployment.Libraries.AllowTenantPublish',
                isInternalDeployment: 'Deployment.Libraries.Internal',
                deploymentUrl: 'Deployment.Libraries.Url',
                authenticationType: 'Deployment.Libraries.AuthenticationType',
                apiKey: 'NuGet.Activities.ApiKey',
            },
        },
        application: {
            termsAndConditionsRegisterUrl: 'TermsAndConditionsRegisterUrl',
            isTenantRegistrationEnabled: 'Tenant.Registration.Enabled',
            customTitle: 'CustomTitle',
        },
    };
    MapperService.getInverseMap = function (originalMap) {
        var inverseMap = {};
        var keys = Object.keys(originalMap);
        for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
            var key = keys_2[_i];
            inverseMap[originalMap[key]] = key;
        }
        return inverseMap;
    };
    MapperService.getInverseSettingsMap = function () {
        var map = {};
        var inverseMapping = function (prefix, currentMap) {
            if (typeof currentMap === 'string') {
                map[currentMap] = prefix.map(function (p) {
                    var newKey = p[0].toUpperCase() + p.substring(1);
                    return newKey;
                }).join('.');
            }
            else {
                Object.keys(currentMap).forEach(function (key) {
                    var newPrefix = prefix.slice(0);
                    newPrefix.push(key);
                    inverseMapping(newPrefix, currentMap[key]);
                });
            }
        };
        inverseMapping([], MapperService.settingsMappings);
        return map;
    };
    return MapperService;
}());
export { MapperService };
export { ɵ0, ɵ1 };
